// extracted by mini-css-extract-plugin
module.exports = {"hidden":"styles_hidden__1eWOk","anchor":"styles_anchor__2ltQI","title":"styles_title__1YeLz"};